<template>
  <div class="fill-height">
    <v-container v-if="loading" class="fill-height">
      <v-row>
        <v-col>
          <v-progress-circular indeterminate />
        </v-col>
      </v-row>
    </v-container>

    <template v-else-if="assessment && assessment.quiz">
      <!--assessment content quiz timer-->
      <v-row
        v-if="isQuizRunning"
        class="primary ma-0 py-1"
        justify="center"
        align="center"
      >
        <v-col class="text-start ps-8">
          <span class="text-h6 light--text">
            {{ $t("course.timedQuiz") }}
          </span>
        </v-col>

        <v-spacer />

        <v-col class="text-end pe-16">
          <div class="d-flex justify-end align-center">
            <span class="light--text textLight rounded-2 px-4 text-h4">
              <v-icon size="30" color="white" class="pe-1">
                mdi-timer-outline
              </v-icon>

              <span ref="quizTimerText"> 00:00 </span>
            </span>

            <div
              class="text-start ms-3 subtitle-2 light--text font-weight-light"
            >
              <p class="ma-0">
                {{ $t("course.minutes") }}
              </p>

              <p class="ma-0">
                {{ $t("course.remaining") }}
              </p>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-container fluid class="fill-height align-start pa-8">
        <v-row>
          <!--assessment content-->
          <v-col cols="12" md="7" class="pe-md-8">
            <AssessmentContent
              :assessment="assessment"
              @onQuizTimerUpdate="onQuizTimerUpdate"
            />
          </v-col>
        </v-row>
      </v-container>
    </template>

    <v-container v-else class="fill-height">
      <Error />
    </v-container>
  </div>
</template>

<script>
import Error from "../../core-module/components/Error";
import AssessmentContent from "../components/AssessmentContent";

export default {
  name: "AssessmentDetailsPage",
  components: {
    Error,
    AssessmentContent,
  },
  data() {
    return {
      loading: true,
      assessment: null,
      isQuizRunning: false,
    };
  },
  created() {
    if (this.$route.params.assessment) {
      this.assessment = this.$route.params.assessment;
      this.loading = false;
    } else if (this.$route.params.id) {
      this.$apollo.addSmartQuery("getQuizContent", {
        query: require("../api/query/getQuizContent.gql"),
        variables: { id: this.$route.params.id },
        result({ data, loading }) {
          if (data?.getQuizContent) {
            this.assessment = data.getQuizContent;
          }

          this.loading = loading;
        },
      });
    }
  },
  methods: {
    onQuizTimerUpdate(quizTimerObject) {
      this.isQuizRunning = quizTimerObject.isQuizRunning;

      if (this.$refs["quizTimerText"]) {
        this.$refs["quizTimerText"].innerText = quizTimerObject.duration;
      }
    },
  },
};
</script>

<style lang="scss" scoped />
